import {css} from 'styled-components';

export const truncateString = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
